import './portfolio-immobiliare-sorter.scss';

/**
 * version    1.0
 * class      PortfolioImmobiliareSorter
 *
 * Gestisce il dropdown di ordinamento del portfolio immobiliare.
 * Alla selezione di un'opzione aggiorna il testo del trigger e
 * marca visivamente la voce attiva.
 */
export class PortfolioImmobiliareSorter {
  constructor(element) {
    this.element = element || document.querySelector('[data-component="portfolio-immobiliare-sorter"]');
    if (this.element) {
      this.init();
    }
  }

  init() {
    this.trigger = this.element.querySelector('#sorterDropdownTrigger');
    this.options = Array.from(this.element.querySelectorAll('.portfolio-immobiliare-sorter__option'));

    this.bindEvents();
  }

  bindEvents() {
    this.options.forEach((option) => {
      // Selezione via click
      option.addEventListener('click', () => this.selectOption(option));

      // Selezione via tastiera (Enter / Space)
      option.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.selectOption(option);
        }
      });
    });
  }

  selectOption(selected) {
    // Rimuove is-selected da tutte le opzioni
    this.options.forEach((opt) => opt.classList.remove('is-selected'));

    // Marca la voce selezionata
    selected.classList.add('is-selected');

    // Aggiorna il testo del trigger
    const label = this.trigger && this.trigger.querySelector('span');
    if (label) label.textContent = selected.textContent.trim();

    // Chiude il dropdown Bootstrap
    const dropdownEl = this.trigger;
    if (dropdownEl && window.bootstrap) {
      const instance = window.bootstrap.Dropdown.getInstance(dropdownEl);
      if (instance) instance.hide();
    }
  }
}
